<template>
  <b-navbar-brand href="#" class="align-items-center justify-content-center">
    <!-- Logo icon -->
      <!--You can put here icon as well -->
      <!-- Light Logo icon -->

  </b-navbar-brand>
</template>

<script>
export default {
  name: "LogoDark",
};
</script>
